import { Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

interface EmptyStateProps {
	title: string;
	message: string;
}

function EmptyState({ title, message }: EmptyStateProps) {
	return (
		<Alert
			icon={<IconAlertCircle size={16} />}
			title={title}
			variant="light">
			{message}
		</Alert>
	);
}

export default EmptyState;
